import React, { useState, useEffect } from 'react';
import { useData } from '../context/DataContext';
import { isPrerender } from '../utils/isPrerender';
import Seo from './Seo';
import SectionTitle from './SectionTitle';

const Matchs = () => {
  const { 
    equipes, 
    matchs, 
    equipesLoading, 
    matchsLoading, 
    fetchEquipes, 
    fetchAllMatchs 
  } = useData();
  
  const [selectedEquipe, setSelectedEquipe] = useState('');

  useEffect(() => {
    if (isPrerender()) return;
    fetchEquipes();
  }, [fetchEquipes]);

  // Quand les équipes sont chargées, sélectionner la première et charger tous les matchs
  useEffect(() => {
    if (equipes.length > 0) {
      if (!selectedEquipe) {
        setSelectedEquipe(equipes[0].liendivision);
      }
      // Charge tous les matchs une seule fois
      fetchAllMatchs(equipes);
    }
  }, [equipes, selectedEquipe, fetchAllMatchs]);

  // matchsLoading démarre à true mais ne se résout que s'il y a des équipes :
  // on ne l'attend donc que dans ce cas.
  const loading = equipesLoading || (equipes.length > 0 && matchsLoading);

  return (
    <div className='container container-matchs'>
      <Seo
        path="/matchs"
        title="Calendrier des matchs"
        description="Calendrier et résultats des rencontres par équipes du Tennis de Table Briançon en championnat FFTT."
      />
      <SectionTitle as="h1" overline="Championnat">
        Calendrier des matchs
      </SectionTitle>

      <p className="page-intro">
        Consultez le calendrier et les résultats des rencontres par équipes du
        club en championnat FFTT. Sélectionnez une équipe pour afficher son
        programme complet : dates, adversaires et scores des matchs déjà joués.
        Les rencontres à domicile se disputent au Vieux gymnase des Garcins, à
        Briançon. Les informations sont synchronisées avec les données officielles
        de la fédération.
      </p>

      {loading ? (
        <div className="text-center mt-4">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement en cours...</span>
          </div>
        </div>
      ) : !Array.isArray(equipes) || equipes.length === 0 ? (
        <p className="page-empty">Aucun match à afficher pour le moment.</p>
      ) : (
        <>
          <div className="form-group mb-4">
            <label className="col-form-label" htmlFor="equipe-select">Équipe</label>
            <select
              id="equipe-select"
              className="form-control"
              value={selectedEquipe || ""}
              onChange={(e) => setSelectedEquipe(e.target.value)}
            >
              {equipes.map((equipe) => (
                <option key={equipe.liendivision} value={equipe.liendivision}>
                  {equipe.libequipe}
                </option>
              ))}
            </select>
          </div>

          {selectedEquipe && (
            <div className="mt-2">
              {matchs[selectedEquipe]?.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead className="thead-dark">
                    <tr>
                      <th>Date</th>
                      <th>Équipe A</th>
                      <th>Score A</th>
                      <th>Score B</th>
                      <th>Équipe B</th>
                    </tr>
                  </thead>
                  <tbody>
                    {matchs[selectedEquipe].map((match, index) => (
                      <tr key={`${match.idequipe}-${index}`}>
                        <td>{match.datereelle || match.dateprevue}</td>
                        <td>{match.equa || 'AUCUNE EQUIPE'}</td>
                        <td>{match.scorea}</td>
                        <td>{match.scoreb}</td>
                        <td>{match.equb || 'AUCUNE EQUIPE'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              ) : (
                <p className="text-center">Aucun match pour cette équipe.</p>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Matchs;